import { IDepartment, IResearcher } from '../constants/types';

// SHER-446 — resolve which departments the request department selector should
// offer for a given researcher, kept dependency-free so it can be unit-tested
// without the Redux/hospital data layer.
//
// - No researcher resolved (e.g. the current user isn't in the loaded list yet)
//   → all departments (never block the user).
// - onlyResearcherIfSingle = false (default; e.g. analytics filter) → the
//   researcher's own departments, as before.
// - onlyResearcherIfSingle = true (request form) → narrow to the researcher's
//   own departments ONLY when there is exactly one (so the field pre-fills and
//   hides for a doctor in a single service); with zero or several, fall back to
//   all so the user keeps the full hospital list.
export function resolveResearcherDepartments(
  allDepartments: IDepartment[],
  researcher: IResearcher | undefined | null,
  onlyResearcherIfSingle: boolean = false,
): IDepartment[] {
  if (!researcher) {
    return [...allDepartments];
  }

  const byUuid: { [uuid: string]: IDepartment } = {};
  (researcher.units || []).forEach((unit: any) => {
    const department = allDepartments.find((d) => d.uuid === unit.department?.uuid);
    if (department) {
      byUuid[unit.department.uuid as string] = department;
    }
  });
  const researcherDepartments = Object.values(byUuid);

  if (onlyResearcherIfSingle) {
    return researcherDepartments.length === 1 ? researcherDepartments : [...allDepartments];
  }
  return researcherDepartments;
}
